import {AnimatePresence} from 'framer-motion';
import {FC} from 'react';
import * as Styles from './handle.styles';

interface HandleProps {
  position: string;
  visible: boolean;
}

const hidden = {opacity: 0, scale: 0};

export const Handle: FC<HandleProps> = ({position, visible}) => (
  <AnimatePresence>
    <Styles.Container left={position}>
      {visible && (
        <Styles.Wrapper
          initial={hidden}
          exit={hidden}
          animate={{opacity: 1, scale: 1}}
          key="handle"
        />
      )}
    </Styles.Container>
  </AnimatePresence>
);
